const MockData = {
  data: [
    {
      id: "2",
      mro_name: "MRO Center A",
      sku_name: "Turbine Blades/Vanes",
      sku_desc: "Description of SKU",
      threshold_quantity: 450,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 120,
    },
    {
      id: "3",
      mro_name: "MRO Center A",
      sku_name: "Fuel Nozzles",
      sku_desc: "Description of SKU",
      threshold_quantity: 380,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 140,
    },
    {
      id: "4",
      mro_name: "MRO Center A",
      sku_name: "Combustion Liners",
      sku_desc: "Description of SKU",
      threshold_quantity: 370,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 190,
    },
    {
      id: "5",
      mro_name: "MRO Center A",
      sku_name: "Compressor Blades/Disc",
      sku_desc: "Description of SKU",
      threshold_quantity: 60,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 200,
    },
    {
      id: "6",
      mro_name: "MRO Center B",
      sku_name: "Turbine Blades/Vanes",
      sku_desc: "Description of SKU",
      threshold_quantity: 350,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 120,
    },
    {
      id: "7",
      mro_name: "MRO Center B",
      sku_name: "Fuel Nozzles",
      sku_desc: "Description of SKU",
      threshold_quantity: 480,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 140,
    },
    {
      id: "8",
      mro_name: "MRO Center B",
      sku_name: "Combustion Liners",
      sku_desc: "Description of SKU",
      threshold_quantity: 170,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 190,
    },
    {
      id: "9",
      mro_name: "MRO Center B",
      sku_name: "Compressor Blades/Disc",
      sku_desc: "Description of SKU",
      threshold_quantity: 60,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 200,
    },
    {
      id: "10",
      mro_name: "MRO Center C",
      sku_name: "Turbine Blades/Vanes",
      sku_desc: "Description of SKU",
      threshold_quantity: 350,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 120,
    },
    {
      id: "11",
      mro_name: "MRO Center C",
      sku_name: "Fuel Nozzles",
      sku_desc: "Description of SKU",
      threshold_quantity: 280,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 140,
    },
    {
      id: "12",
      mro_name: "MRO Center C",
      sku_name: "Combustion Liners",
      sku_desc: "Description of SKU",
      threshold_quantity: 570,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 190,
    },
    {
      id: "13",
      mro_name: "MRO Center C",
      sku_name: "Compressor Blades/Disc",
      sku_desc: "Description of SKU",
      threshold_quantity: 260,
      avg_lead_time: 10,
      demand_std_dev: 10,
      lead_time_std_dev: 15,
      service_factor: 0.5,
      avg_sales: 200,
    },
  ],

  sku_data: {
    "MRO Center A": [
      {
        date: "06/01/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/02/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 250,
      },
      {
        date: "06/03/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 365,
        stock: 300,
      },
      {
        date: "06/04/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 390,
        stock: 320,
      },
      {
        date: "06/05/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 410,
        stock: 380,
      },
      {
        date: "06/06/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 330,
        stock: 300,
      },
      {
        date: "06/07/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 430,
      },
      {
        date: "06/08/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 440,
        stock: 390,
      },
      {
        date: "06/09/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 460,
        stock: 410,
      },
      {
        date: "06/10/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 420,
        stock: 370,
      },
      {
        date: "06/11/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 350,
        stock: 300,
      },
      {
        date: "06/12/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/13/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 310,
        stock: 270,
      },
      {
        date: "06/14/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 480,
        stock: 420,
      },
      {
        date: "06/15/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 450,
        stock: 410,
      },
      {
        date: "06/16/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 400,
        stock: 370,
      },
      {
        date: "06/17/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 490,
        stock: 420,
      },
      {
        date: "06/18/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 430,
        stock: 400,
      },
      {
        date: "06/19/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 350,
        stock: 300,
      },
      {
        date: "06/20/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 460,
        stock: 420,
      },
      {
        date: "06/21/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 440,
        stock: 400,
      },
      {
        date: "06/22/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 320,
        stock: 290,
      },
      {
        date: "06/23/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 410,
      },
      {
        date: "06/24/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 450,
        stock: 390,
      },
      {
        date: "06/25/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 410,
        stock: 370,
      },
      {
        date: "06/26/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 480,
        stock: 400,
      },
      {
        date: "06/27/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 430,
      },
      {
        date: "06/28/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 340,
        stock: 310,
      },
      {
        date: "06/29/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 460,
        stock: 390,
      },
      {
        date: "06/30/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 450,
        stock: 380,
      },

      { date: "06/01/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 290 },
      { date: "06/02/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 250 },
      { date: "06/03/2024", sku_name: "Fuel Nozzles", demand: 260, stock: 240 },
      { date: "06/04/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 260 },
      { date: "06/05/2024", sku_name: "Fuel Nozzles", demand: 320, stock: 290 },
      { date: "06/06/2024", sku_name: "Fuel Nozzles", demand: 340, stock: 300 },
      { date: "06/07/2024", sku_name: "Fuel Nozzles", demand: 320, stock: 200 },
      { date: "06/08/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 210 },
      { date: "06/09/2024", sku_name: "Fuel Nozzles", demand: 300, stock: 220 },
      { date: "06/10/2024", sku_name: "Fuel Nozzles", demand: 325, stock: 245 },
      { date: "06/11/2024", sku_name: "Fuel Nozzles", demand: 350, stock: 200 },
      { date: "06/12/2024", sku_name: "Fuel Nozzles", demand: 330, stock: 180 },
      { date: "06/13/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 150 },
      { date: "06/14/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 70 },
      { date: "06/15/2024", sku_name: "Fuel Nozzles", demand: 260, stock: 50 },
      { date: "06/16/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 70 },
      { date: "06/17/2024", sku_name: "Fuel Nozzles", demand: 320, stock: 80 },
      { date: "06/18/2024", sku_name: "Fuel Nozzles", demand: 340, stock: 90 },
      { date: "06/19/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 50 },
      { date: "06/20/2024", sku_name: "Fuel Nozzles", demand: 300, stock: 30 },
      { date: "06/21/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 20 },
      { date: "06/22/2024", sku_name: "Fuel Nozzles", demand: 250, stock: 90 },
      { date: "06/23/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 20 },
      { date: "06/24/2024", sku_name: "Fuel Nozzles", demand: 300, stock: 30 },
      { date: "06/25/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 40 },
      { date: "06/26/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 10 },
      { date: "06/27/2024", sku_name: "Fuel Nozzles", demand: 320, stock: 15 },
      { date: "06/28/2024", sku_name: "Fuel Nozzles", demand: 320, stock: 10 },
      { date: "06/29/2024", sku_name: "Fuel Nozzles", demand: 225, stock: 15 },
      { date: "06/30/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 16 },

      {
        date: "06/01/2024",
        sku_name: "Combustion Liners",
        demand: 490,
        stock: 400,
      },
      {
        date: "06/02/2024",
        sku_name: "Combustion Liners",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/03/2024",
        sku_name: "Combustion Liners",
        demand: 450,
        stock: 360,
      },
      {
        date: "06/04/2024",
        sku_name: "Combustion Liners",
        demand: 430,
        stock: 340,
      },
      {
        date: "06/05/2024",
        sku_name: "Combustion Liners",
        demand: 410,
        stock: 320,
      },
      {
        date: "06/06/2024",
        sku_name: "Combustion Liners",
        demand: 390,
        stock: 300,
      },
      {
        date: "06/07/2024",
        sku_name: "Combustion Liners",
        demand: 370,
        stock: 280,
      },
      {
        date: "06/08/2024",
        sku_name: "Combustion Liners",
        demand: 350,
        stock: 260,
      },
      {
        date: "06/09/2024",
        sku_name: "Combustion Liners",
        demand: 330,
        stock: 240,
      },
      {
        date: "06/10/2024",
        sku_name: "Combustion Liners",
        demand: 310,
        stock: 220,
      },
      {
        date: "06/11/2024",
        sku_name: "Combustion Liners",
        demand: 290,
        stock: 200,
      },
      {
        date: "06/12/2024",
        sku_name: "Combustion Liners",
        demand: 270,
        stock: 180,
      },
      {
        date: "06/13/2024",
        sku_name: "Combustion Liners",
        demand: 250,
        stock: 160,
      },
      {
        date: "06/14/2024",
        sku_name: "Combustion Liners",
        demand: 230,
        stock: 140,
      },
      {
        date: "06/15/2024",
        sku_name: "Combustion Liners",
        demand: 210,
        stock: 120,
      },
      {
        date: "06/16/2024",
        sku_name: "Combustion Liners",
        demand: 190,
        stock: 100,
      },
      {
        date: "06/17/2024",
        sku_name: "Combustion Liners",
        demand: 170,
        stock: 80,
      },
      {
        date: "06/18/2024",
        sku_name: "Combustion Liners",
        demand: 150,
        stock: 60,
      },
      {
        date: "06/19/2024",
        sku_name: "Combustion Liners",
        demand: 130,
        stock: 40,
      },
      {
        date: "06/20/2024",
        sku_name: "Combustion Liners",
        demand: 110,
        stock: 20,
      },
      {
        date: "06/21/2024",
        sku_name: "Combustion Liners",
        demand: 130,
        stock: 30,
      },
      {
        date: "06/22/2024",
        sku_name: "Combustion Liners",
        demand: 150,
        stock: 50,
      },
      {
        date: "06/23/2024",
        sku_name: "Combustion Liners",
        demand: 170,
        stock: 70,
      },
      {
        date: "06/24/2024",
        sku_name: "Combustion Liners",
        demand: 190,
        stock: 90,
      },
      {
        date: "06/25/2024",
        sku_name: "Combustion Liners",
        demand: 210,
        stock: 110,
      },
      {
        date: "06/26/2024",
        sku_name: "Combustion Liners",
        demand: 230,
        stock: 130,
      },
      {
        date: "06/27/2024",
        sku_name: "Combustion Liners",
        demand: 250,
        stock: 150,
      },
      {
        date: "06/28/2024",
        sku_name: "Combustion Liners",
        demand: 270,
        stock: 170,
      },
      {
        date: "06/29/2024",
        sku_name: "Combustion Liners",
        demand: 290,
        stock: 190,
      },
      {
        date: "06/30/2024",
        sku_name: "Combustion Liners",
        demand: 310,
        stock: 210,
      },

      {
        date: "06/01/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 410,
        stock: 330,
      },
      {
        date: "06/02/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 390,
        stock: 310,
      },
      {
        date: "06/03/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 370,
        stock: 290,
      },
      {
        date: "06/04/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 350,
        stock: 270,
      },
      {
        date: "06/05/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/06/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/07/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/08/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/09/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/10/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/11/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/12/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/13/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/14/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/15/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/16/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/17/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 90,
        stock: 10,
      },
      {
        date: "06/18/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/19/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/20/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/21/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/22/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/23/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/24/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/25/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/26/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/27/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/28/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/29/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/30/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 350,
        stock: 270,
      },
      {
        date: "07/01/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 370,
        stock: 280,
      },
      {
        date: "07/02/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 250,
      },
      {
        date: "07/03/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 365,
        stock: 300,
      },
      {
        date: "07/04/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 390,
        stock: 220,
      },
      {
        date: "07/01/2024",
        sku_name: "Fuel Nozzles",
        demand: 280,
        stock: 200,
      },
      {
        date: "07/02/2024",
        sku_name: "Fuel Nozzles",
        demand: 225,
        stock: 65,
      },
      {
        date: "07/03/2024",
        sku_name: "Fuel Nozzles",
        demand: 125,
        stock: 45,
      },
      {
        date: "07/04/2024",
        sku_name: "Fuel Nozzles",
        demand: 125,
        stock: 45,
      },
      {
        date: "07/01/2024",
        sku_name: "Combustion Liners",
        demand: 215,
        stock: 125,
      },
      {
        date: "07/02/2024",
        sku_name: "Combustion Liners",
        demand: 240,
        stock: 100,
      },
      {
        date: "07/03/2024",
        sku_name: "Combustion Liners",
        demand: 160,
        stock: 50,
      },
      {
        date: "07/04/2024",
        sku_name: "Combustion Liners",
        demand: 160,
        stock: 50,
      },
      {
        date: "07/01/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 120,
      },
      {
        date: "07/02/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 80,
        stock: 90,
      },
      {
        date: "07/03/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 120,
        stock: 170,
      },
      {
        date: "07/04/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 240,
        stock: 180,
      },
    ],
    "MRO Center B": [
      {
        date: "06/01/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 390,
        stock: 300,
      },
      {
        date: "06/02/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 370,
        stock: 280,
      },
      {
        date: "06/03/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 350,
        stock: 260,
      },
      {
        date: "06/04/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 330,
        stock: 240,
      },
      {
        date: "06/05/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 310,
        stock: 220,
      },
      {
        date: "06/06/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 200,
      },
      {
        date: "06/07/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 270,
        stock: 180,
      },
      {
        date: "06/08/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 250,
        stock: 160,
      },
      {
        date: "06/09/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 230,
        stock: 140,
      },
      {
        date: "06/10/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 210,
        stock: 120,
      },
      {
        date: "06/11/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 190,
        stock: 100,
      },
      {
        date: "06/12/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 170,
        stock: 80,
      },
      {
        date: "06/13/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 150,
        stock: 60,
      },
      {
        date: "06/14/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 130,
        stock: 40,
      },
      {
        date: "06/15/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 110,
        stock: 20,
      },
      {
        date: "06/16/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 90,
        stock: 10,
      },
      {
        date: "06/17/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/18/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/19/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/20/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/21/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/22/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/23/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/24/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/25/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/26/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/27/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/28/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/29/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 350,
        stock: 270,
      },
      {
        date: "06/30/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 370,
        stock: 290,
      },

      { date: "06/01/2024", sku_name: "Fuel Nozzles", demand: 430, stock: 340 },
      { date: "06/02/2024", sku_name: "Fuel Nozzles", demand: 410, stock: 320 },
      { date: "06/03/2024", sku_name: "Fuel Nozzles", demand: 390, stock: 300 },
      { date: "06/04/2024", sku_name: "Fuel Nozzles", demand: 370, stock: 280 },
      { date: "06/05/2024", sku_name: "Fuel Nozzles", demand: 350, stock: 260 },
      { date: "06/06/2024", sku_name: "Fuel Nozzles", demand: 330, stock: 240 },
      { date: "06/07/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 220 },
      { date: "06/08/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 200 },
      { date: "06/09/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 180 },
      { date: "06/10/2024", sku_name: "Fuel Nozzles", demand: 250, stock: 160 },
      { date: "06/11/2024", sku_name: "Fuel Nozzles", demand: 230, stock: 140 },
      { date: "06/12/2024", sku_name: "Fuel Nozzles", demand: 210, stock: 120 },
      { date: "06/13/2024", sku_name: "Fuel Nozzles", demand: 190, stock: 100 },
      { date: "06/14/2024", sku_name: "Fuel Nozzles", demand: 170, stock: 80 },
      { date: "06/15/2024", sku_name: "Fuel Nozzles", demand: 150, stock: 60 },
      { date: "06/16/2024", sku_name: "Fuel Nozzles", demand: 130, stock: 40 },
      { date: "06/17/2024", sku_name: "Fuel Nozzles", demand: 110, stock: 20 },
      { date: "06/18/2024", sku_name: "Fuel Nozzles", demand: 90, stock: 10 },
      { date: "06/19/2024", sku_name: "Fuel Nozzles", demand: 110, stock: 30 },
      { date: "06/20/2024", sku_name: "Fuel Nozzles", demand: 130, stock: 50 },
      { date: "06/21/2024", sku_name: "Fuel Nozzles", demand: 150, stock: 70 },
      { date: "06/22/2024", sku_name: "Fuel Nozzles", demand: 170, stock: 90 },
      { date: "06/23/2024", sku_name: "Fuel Nozzles", demand: 190, stock: 110 },
      { date: "06/24/2024", sku_name: "Fuel Nozzles", demand: 210, stock: 130 },
      { date: "06/25/2024", sku_name: "Fuel Nozzles", demand: 230, stock: 150 },
      { date: "06/26/2024", sku_name: "Fuel Nozzles", demand: 250, stock: 170 },
      { date: "06/27/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 190 },
      { date: "06/28/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 210 },
      { date: "06/29/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 230 },
      { date: "06/30/2024", sku_name: "Fuel Nozzles", demand: 330, stock: 250 },

      {
        date: "06/01/2024",
        sku_name: "Combustion Liners",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/02/2024",
        sku_name: "Combustion Liners",
        demand: 450,
        stock: 360,
      },
      {
        date: "06/03/2024",
        sku_name: "Combustion Liners",
        demand: 430,
        stock: 340,
      },
      {
        date: "06/04/2024",
        sku_name: "Combustion Liners",
        demand: 410,
        stock: 320,
      },
      {
        date: "06/05/2024",
        sku_name: "Combustion Liners",
        demand: 390,
        stock: 300,
      },
      {
        date: "06/06/2024",
        sku_name: "Combustion Liners",
        demand: 370,
        stock: 280,
      },
      {
        date: "06/07/2024",
        sku_name: "Combustion Liners",
        demand: 350,
        stock: 260,
      },
      {
        date: "06/08/2024",
        sku_name: "Combustion Liners",
        demand: 330,
        stock: 240,
      },
      {
        date: "06/09/2024",
        sku_name: "Combustion Liners",
        demand: 310,
        stock: 220,
      },
      {
        date: "06/10/2024",
        sku_name: "Combustion Liners",
        demand: 290,
        stock: 200,
      },
      {
        date: "06/11/2024",
        sku_name: "Combustion Liners",
        demand: 270,
        stock: 180,
      },
      {
        date: "06/12/2024",
        sku_name: "Combustion Liners",
        demand: 250,
        stock: 160,
      },
      {
        date: "06/13/2024",
        sku_name: "Combustion Liners",
        demand: 230,
        stock: 140,
      },
      {
        date: "06/14/2024",
        sku_name: "Combustion Liners",
        demand: 210,
        stock: 120,
      },
      {
        date: "06/15/2024",
        sku_name: "Combustion Liners",
        demand: 190,
        stock: 100,
      },
      {
        date: "06/16/2024",
        sku_name: "Combustion Liners",
        demand: 170,
        stock: 80,
      },
      {
        date: "06/17/2024",
        sku_name: "Combustion Liners",
        demand: 150,
        stock: 60,
      },
      {
        date: "06/18/2024",
        sku_name: "Combustion Liners",
        demand: 130,
        stock: 40,
      },
      {
        date: "06/19/2024",
        sku_name: "Combustion Liners",
        demand: 110,
        stock: 20,
      },
      {
        date: "06/20/2024",
        sku_name: "Combustion Liners",
        demand: 130,
        stock: 30,
      },
      {
        date: "06/21/2024",
        sku_name: "Combustion Liners",
        demand: 150,
        stock: 50,
      },
      {
        date: "06/22/2024",
        sku_name: "Combustion Liners",
        demand: 170,
        stock: 70,
      },
      {
        date: "06/23/2024",
        sku_name: "Combustion Liners",
        demand: 190,
        stock: 90,
      },
      {
        date: "06/24/2024",
        sku_name: "Combustion Liners",
        demand: 210,
        stock: 110,
      },
      {
        date: "06/25/2024",
        sku_name: "Combustion Liners",
        demand: 230,
        stock: 130,
      },
      {
        date: "06/26/2024",
        sku_name: "Combustion Liners",
        demand: 250,
        stock: 150,
      },
      {
        date: "06/27/2024",
        sku_name: "Combustion Liners",
        demand: 270,
        stock: 170,
      },
      {
        date: "06/28/2024",
        sku_name: "Combustion Liners",
        demand: 290,
        stock: 190,
      },
      {
        date: "06/29/2024",
        sku_name: "Combustion Liners",
        demand: 310,
        stock: 210,
      },
      {
        date: "06/30/2024",
        sku_name: "Combustion Liners",
        demand: 330,
        stock: 230,
      },

      {
        date: "06/01/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 390,
        stock: 310,
      },
      {
        date: "06/02/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 370,
        stock: 290,
      },
      {
        date: "06/03/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 350,
        stock: 270,
      },
      {
        date: "06/04/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/05/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/06/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/07/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/08/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/09/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/10/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/11/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/12/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/13/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/14/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/15/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/16/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 90,
        stock: 10,
      },
      {
        date: "06/17/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/18/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/19/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/20/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/21/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/22/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/23/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/24/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/25/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/26/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/27/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/28/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/29/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 350,
        stock: 270,
      },
      {
        date: "06/30/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 370,
        stock: 290,
      },
      {
        date: "07/01/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 370,
        stock: 280,
      },
      {
        date: "07/02/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 250,
      },
      {
        date: "07/03/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 365,
        stock: 300,
      },
      {
        date: "07/04/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 390,
        stock: 220,
      },
      {
        date: "07/01/2024",
        sku_name: "Fuel Nozzles",
        demand: 280,
        stock: 200,
      },
      {
        date: "07/02/2024",
        sku_name: "Fuel Nozzles",
        demand: 225,
        stock: 65,
      },
      {
        date: "07/03/2024",
        sku_name: "Fuel Nozzles",
        demand: 125,
        stock: 45,
      },
      {
        date: "07/04/2024",
        sku_name: "Fuel Nozzles",
        demand: 125,
        stock: 45,
      },
      {
        date: "07/01/2024",
        sku_name: "Combustion Liners",
        demand: 215,
        stock: 125,
      },
      {
        date: "07/02/2024",
        sku_name: "Combustion Liners",
        demand: 240,
        stock: 100,
      },
      {
        date: "07/03/2024",
        sku_name: "Combustion Liners",
        demand: 160,
        stock: 50,
      },
      {
        date: "07/04/2024",
        sku_name: "Combustion Liners",
        demand: 160,
        stock: 50,
      },
      {
        date: "07/01/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 120,
      },
      {
        date: "07/02/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 80,
        stock: 90,
      },
      {
        date: "07/03/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 120,
        stock: 170,
      },
      {
        date: "07/04/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 240,
        stock: 180,
      },
    ],
    "MRO Center C": [
      {
        date: "06/01/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/02/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 250,
      },
      {
        date: "06/03/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 365,
        stock: 300,
      },
      {
        date: "06/04/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 390,
        stock: 320,
      },
      {
        date: "06/05/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 410,
        stock: 380,
      },
      {
        date: "06/06/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 330,
        stock: 300,
      },
      {
        date: "06/07/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 430,
      },
      {
        date: "06/08/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 440,
        stock: 390,
      },
      {
        date: "06/09/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 460,
        stock: 410,
      },
      {
        date: "06/10/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 420,
        stock: 370,
      },
      {
        date: "06/11/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 350,
        stock: 300,
      },
      {
        date: "06/12/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/13/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 310,
        stock: 270,
      },
      {
        date: "06/14/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 480,
        stock: 420,
      },
      {
        date: "06/15/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 450,
        stock: 410,
      },
      {
        date: "06/16/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 400,
        stock: 370,
      },
      {
        date: "06/17/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 490,
        stock: 420,
      },
      {
        date: "06/18/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 430,
        stock: 400,
      },
      {
        date: "06/19/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 350,
        stock: 300,
      },
      {
        date: "06/20/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 460,
        stock: 420,
      },
      {
        date: "06/21/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 440,
        stock: 400,
      },
      {
        date: "06/22/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 320,
        stock: 290,
      },
      {
        date: "06/23/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 410,
      },
      {
        date: "06/24/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 450,
        stock: 390,
      },
      {
        date: "06/25/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 410,
        stock: 370,
      },
      {
        date: "06/26/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 480,
        stock: 400,
      },
      {
        date: "06/27/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 470,
        stock: 430,
      },
      {
        date: "06/28/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 340,
        stock: 310,
      },
      {
        date: "06/29/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 460,
        stock: 390,
      },
      {
        date: "06/30/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 450,
        stock: 380,
      },

      { date: "06/01/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 200 },
      { date: "06/02/2024", sku_name: "Fuel Nozzles", demand: 225, stock: 165 },
      { date: "06/03/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 200 },
      { date: "06/04/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 220 },
      { date: "06/05/2024", sku_name: "Fuel Nozzles", demand: 300, stock: 210 },
      { date: "06/06/2024", sku_name: "Fuel Nozzles", demand: 325, stock: 265 },
      { date: "06/07/2024", sku_name: "Fuel Nozzles", demand: 350, stock: 290 },
      { date: "06/08/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 240 },
      { date: "06/09/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 210 },
      { date: "06/10/2024", sku_name: "Fuel Nozzles", demand: 260, stock: 200 },
      { date: "06/11/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 210 },
      { date: "06/12/2024", sku_name: "Fuel Nozzles", demand: 320, stock: 250 },
      { date: "06/13/2024", sku_name: "Fuel Nozzles", demand: 340, stock: 270 },
      { date: "06/14/2024", sku_name: "Fuel Nozzles", demand: 300, stock: 230 },
      { date: "06/15/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 220 },
      { date: "06/16/2024", sku_name: "Fuel Nozzles", demand: 250, stock: 190 },
      { date: "06/17/2024", sku_name: "Fuel Nozzles", demand: 280, stock: 210 },
      { date: "06/18/2024", sku_name: "Fuel Nozzles", demand: 300, stock: 230 },
      { date: "06/19/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 240 },
      { date: "06/20/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 210 },
      { date: "06/21/2024", sku_name: "Fuel Nozzles", demand: 330, stock: 260 },
      { date: "06/22/2024", sku_name: "Fuel Nozzles", demand: 340, stock: 270 },
      { date: "06/23/2024", sku_name: "Fuel Nozzles", demand: 350, stock: 280 },
      { date: "06/24/2024", sku_name: "Fuel Nozzles", demand: 190, stock: 110 },
      { date: "06/25/2024", sku_name: "Fuel Nozzles", demand: 210, stock: 130 },
      { date: "06/26/2024", sku_name: "Fuel Nozzles", demand: 230, stock: 150 },
      { date: "06/27/2024", sku_name: "Fuel Nozzles", demand: 250, stock: 170 },
      { date: "06/28/2024", sku_name: "Fuel Nozzles", demand: 270, stock: 190 },
      { date: "06/29/2024", sku_name: "Fuel Nozzles", demand: 290, stock: 210 },
      { date: "06/30/2024", sku_name: "Fuel Nozzles", demand: 310, stock: 230 },

      {
        date: "06/01/2024",
        sku_name: "Combustion Liners",
        demand: 490,
        stock: 400,
      },
      {
        date: "06/02/2024",
        sku_name: "Combustion Liners",
        demand: 470,
        stock: 380,
      },
      {
        date: "06/03/2024",
        sku_name: "Combustion Liners",
        demand: 450,
        stock: 360,
      },
      {
        date: "06/04/2024",
        sku_name: "Combustion Liners",
        demand: 430,
        stock: 340,
      },
      {
        date: "06/05/2024",
        sku_name: "Combustion Liners",
        demand: 410,
        stock: 320,
      },
      {
        date: "06/06/2024",
        sku_name: "Combustion Liners",
        demand: 390,
        stock: 300,
      },
      {
        date: "06/07/2024",
        sku_name: "Combustion Liners",
        demand: 370,
        stock: 280,
      },
      {
        date: "06/08/2024",
        sku_name: "Combustion Liners",
        demand: 350,
        stock: 260,
      },
      {
        date: "06/09/2024",
        sku_name: "Combustion Liners",
        demand: 330,
        stock: 240,
      },
      {
        date: "06/10/2024",
        sku_name: "Combustion Liners",
        demand: 310,
        stock: 220,
      },
      {
        date: "06/11/2024",
        sku_name: "Combustion Liners",
        demand: 290,
        stock: 200,
      },
      {
        date: "06/12/2024",
        sku_name: "Combustion Liners",
        demand: 270,
        stock: 180,
      },
      {
        date: "06/13/2024",
        sku_name: "Combustion Liners",
        demand: 250,
        stock: 160,
      },
      {
        date: "06/14/2024",
        sku_name: "Combustion Liners",
        demand: 230,
        stock: 140,
      },
      {
        date: "06/15/2024",
        sku_name: "Combustion Liners",
        demand: 210,
        stock: 120,
      },
      {
        date: "06/16/2024",
        sku_name: "Combustion Liners",
        demand: 190,
        stock: 100,
      },
      {
        date: "06/17/2024",
        sku_name: "Combustion Liners",
        demand: 170,
        stock: 80,
      },
      {
        date: "06/18/2024",
        sku_name: "Combustion Liners",
        demand: 150,
        stock: 60,
      },
      {
        date: "06/19/2024",
        sku_name: "Combustion Liners",
        demand: 130,
        stock: 40,
      },
      {
        date: "06/20/2024",
        sku_name: "Combustion Liners",
        demand: 110,
        stock: 20,
      },
      {
        date: "06/21/2024",
        sku_name: "Combustion Liners",
        demand: 130,
        stock: 30,
      },
      {
        date: "06/22/2024",
        sku_name: "Combustion Liners",
        demand: 150,
        stock: 50,
      },
      {
        date: "06/23/2024",
        sku_name: "Combustion Liners",
        demand: 170,
        stock: 70,
      },
      {
        date: "06/24/2024",
        sku_name: "Combustion Liners",
        demand: 190,
        stock: 90,
      },
      {
        date: "06/25/2024",
        sku_name: "Combustion Liners",
        demand: 210,
        stock: 110,
      },
      {
        date: "06/26/2024",
        sku_name: "Combustion Liners",
        demand: 230,
        stock: 130,
      },
      {
        date: "06/27/2024",
        sku_name: "Combustion Liners",
        demand: 250,
        stock: 150,
      },
      {
        date: "06/28/2024",
        sku_name: "Combustion Liners",
        demand: 270,
        stock: 170,
      },
      {
        date: "06/29/2024",
        sku_name: "Combustion Liners",
        demand: 290,
        stock: 190,
      },
      {
        date: "06/30/2024",
        sku_name: "Combustion Liners",
        demand: 310,
        stock: 210,
      },

      {
        date: "06/01/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 410,
        stock: 330,
      },
      {
        date: "06/02/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 390,
        stock: 310,
      },
      {
        date: "06/03/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 370,
        stock: 290,
      },
      {
        date: "06/04/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 350,
        stock: 270,
      },
      {
        date: "06/05/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/06/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/07/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/08/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/09/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/10/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/11/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/12/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/13/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/14/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/15/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/16/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/17/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 90,
        stock: 10,
      },
      {
        date: "06/18/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 110,
        stock: 30,
      },
      {
        date: "06/19/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 130,
        stock: 50,
      },
      {
        date: "06/20/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 70,
      },
      {
        date: "06/21/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 170,
        stock: 90,
      },
      {
        date: "06/22/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 190,
        stock: 110,
      },
      {
        date: "06/23/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 210,
        stock: 130,
      },
      {
        date: "06/24/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 230,
        stock: 150,
      },
      {
        date: "06/25/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 250,
        stock: 170,
      },
      {
        date: "06/26/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 270,
        stock: 190,
      },
      {
        date: "06/27/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 290,
        stock: 210,
      },
      {
        date: "06/28/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 310,
        stock: 230,
      },
      {
        date: "06/29/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 330,
        stock: 250,
      },
      {
        date: "06/30/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 350,
        stock: 270,
      },
      {
        date: "07/01/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 370,
        stock: 280,
      },
      {
        date: "07/02/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 290,
        stock: 250,
      },
      {
        date: "07/03/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 365,
        stock: 300,
      },
      {
        date: "07/04/2024",
        sku_name: "Turbine Blades/Vanes",
        demand: 390,
        stock: 220,
      },
      {
        date: "07/01/2024",
        sku_name: "Fuel Nozzles",
        demand: 280,
        stock: 200,
      },
      {
        date: "07/02/2024",
        sku_name: "Fuel Nozzles",
        demand: 225,
        stock: 65,
      },
      {
        date: "07/03/2024",
        sku_name: "Fuel Nozzles",
        demand: 125,
        stock: 45,
      },
      {
        date: "07/04/2024",
        sku_name: "Fuel Nozzles",
        demand: 125,
        stock: 45,
      },
      {
        date: "07/01/2024",
        sku_name: "Combustion Liners",
        demand: 215,
        stock: 125,
      },
      {
        date: "07/02/2024",
        sku_name: "Combustion Liners",
        demand: 240,
        stock: 100,
      },
      {
        date: "07/03/2024",
        sku_name: "Combustion Liners",
        demand: 160,
        stock: 50,
      },
      {
        date: "07/04/2024",
        sku_name: "Combustion Liners",
        demand: 160,
        stock: 50,
      },
      {
        date: "07/01/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 150,
        stock: 120,
      },
      {
        date: "07/02/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 80,
        stock: 90,
      },
      {
        date: "07/03/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 120,
        stock: 170,
      },
      {
        date: "07/04/2024",
        sku_name: "Compressor Blades/Disc",
        demand: 240,
        stock: 180,
      },
    ],
  },
};

export default MockData;
